// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';

// IMG
import graphImg from "../../../public/assets/images/inHome/grafico.png";

const BannerVendi: React.FC = () => {
  const { t } = useTranslation();

  const buttonText = t('homePage.sellBanner.cta');

  return (
    <section id="bannerValuta" className="space-ptb">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-5 text-center">
            <img src={graphImg} className="img-fluid mb-4 mb-md-0" alt={`${t('homePage.sellBanner.imgAlt')}`} />
          </div>
          <div className="col-12 col-md-6 col-xl-5 text-center">
            <h2 className="mb-4">{t('homePage.sellBanner.title')}</h2>
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }}></p>
            <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para2') as string }}></p>
            <Link className="btn btn-primary text-uppercase" to="/vendi-casa" title={buttonText}>
              {buttonText}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;